import { render, staticRenderFns } from "./IconChallengeCompleted.vue?vue&type=template&id=0d9e2915&"
import script from "./IconChallengeCompleted.vue?vue&type=script&lang=js&"
export * from "./IconChallengeCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports